import React, { useEffect, useState } from "react";
import logo from "../assest/Images/mindWellIcon.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { RestUserPassword } from "../../api/helper";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ShowToast } from "../../helpers/ToastService";
import Inputbox from "../Components/Inputbox";

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required("New Password is required")
    .min(5, "Password must be at least 5 characters long"),
  newPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get("token");
  const [suggestedPassword, setSuggestedPassword] = useState("");

  useEffect(() => {
    setSuggestedPassword(generateStrongPassword());
  }, []);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });

  const onSubmit = async (data) => {
    let saveData = {
      ...data,
      token: query,
    };
    try {
      const response = await RestUserPassword(saveData);
      ShowToast(response.data.message, "success");
      reset();
      navigate("/success");
    } catch (error) {
      console.log(error);
    }
  };
  const generateStrongPassword = () => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const number = "0123456789";
    const special = "!@#$%^&*_";
    const all = upper + lower + number + special;

    let password = "";
    password += upper[Math.floor(Math.random() * upper.length)];
    password += lower[Math.floor(Math.random() * lower.length)];
    password += number[Math.floor(Math.random() * number.length)];
    password += special[Math.floor(Math.random() * special.length)];

    for (let i = 4; i < 12; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }

    return password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
  };
  return (
    // <div>
    //   <div className="login custom_login--width">
    //     <div className="login_content">
    //       <div className="modal d-block" tabindex="-1">
    //         <div className="modal-dialog">
    //           <div className="modal-content">
    //             <div className="modal-header border-0">
    //               <button
    //                 type="button"
    //                 className="btn-close"
    //                 data-bs-dismiss="modal"
    //                 aria-label="Close"
    //                 onClick={()=>{
    //                   navigate('/')
    //                 }}
    //               ></button>
    //             </div>

    //             <form onSubmit={handleSubmit(onSubmit)} className='w-100'>
    //               <div className="modal-body text-center w-100">
    //                 <img src={logo} alt="logo"style={{height:200,}} />
    //                 <p className="label">Please create your new password</p>

    //   <div className="mb-3">
    //     <label
    //       for="exampleInputPassword1"
    //       className="form-label label"
    //     >
    //       New Password
    //     </label>

    //     <Inputbox
    //   // label="Password"
    //   type="password"
    //   // placeholder="Enter Password"
    //   name="password"
    //   register={register}
    //   isPassword
    // />

    //    {errors.password && <span className="errorMessage">{errors.password.message}</span>}

    //   </div>
    //   <div className="mb-3">
    //     <label
    //       for="exampleInputPassword1"
    //       className="form-label label"
    //     >
    //       Confirm Password
    //     </label>
    //     <Inputbox
    //   // label="Password"
    //   type="password"
    //   // placeholder="Enter Password"
    //   name="newPassword"
    //   register={register}
    //   isPassword
    // />

    //     {errors.newPassword && <span className="errorMessage">{errors.newPassword.message}</span>}
    //   </div>

    //               </div>
    // <div className="modal-footer border-0 text-center d-block w-100">
    //   {/* <Link to="/new-password-success"> */}
    //   <button type="submit" className="btn_dark">
    //   Generate Password
    //   </button>
    //   {/* </Link> */}
    // </div>
    //             </form>

    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="forgot-password-container">
      <div className="forgot-password-modal">
        <button className="close-btn" onClick={() => navigate("/")}>
          &times;
        </button>

        <div className="text-center">
          <img src={logo} alt="Logo" className="forgot-password-logo" />
          <h2 className="forgot-password-title">Forgot Password</h2>
          <p className="forgot-password-subtext">
            Please create your new password
          </p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <Inputbox
              label="Password"
              type="password"
              placeholder="Enter Password"
              name="password"
              register={register}
              isPassword
            />

            {errors.password && (
              <div
                className="errorMessage"
                style={{ marginTop: -17, marginBottom: 10 }}
              >
                {errors.password.message}
              </div>
            )}
          </div>

          <div className="mb-3">
            <Inputbox
              label="Confirm Password"
              type="password"
              placeholder="Enter Confirm Password"
              name="newPassword"
              register={register}
              isPassword
            />

            {errors.newPassword && (
              <div
                className="errorMessage"
                style={{ marginTop: -17, marginBottom: 10 }}
              >
                {errors.newPassword.message}
              </div>
            )}
          </div>
          {suggestedPassword && (
            <div className="suggest-password-box">
              <span>Suggested: </span>
              <button
                type="button"
                className="use-suggested-btn"
                onClick={() => {
                  setValue("password", suggestedPassword);
                  setValue("newPassword", suggestedPassword);
                  clearErrors(["password", "newPassword"]);
                }}
              >
                Use suggested password: <strong>{suggestedPassword}</strong>
              </button>
            </div>
          )}
          <button type="submit" className="btn_dark">
            Generate Password
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
